import React from 'react';
import { ReviewModel } from '../../typings/reviews';
import { SectionWithHeader } from '@vw-marketing/us-components';
import ReviewsCarousel from './reviews-carousel';
import { StyledReviewsPreviewWrapper, StyledCarouselWrapper } from './styled';
import { useReviewModel } from '../../services/reviews-data-service';
import { useFeatureAppConfig } from '../../services/use-feature-app-config';

interface ReviewsPreviewProps {
  reviews?: ReviewModel;
  isModalActive?: boolean;
  handleOnViewAll: (display: boolean) => void;
  setReviews: (reviews?: ReviewModel) => void;
}
const ReviewsPreview = ({
  reviews,
  handleOnViewAll,
  isModalActive,
  setReviews,
}: ReviewsPreviewProps) => {
  const {fiveStarsConfig } = useFeatureAppConfig();
  const {sectionLabel = 'Reviews'} = fiveStarsConfig || {};
  //Component Constants
  const viewAllLabel = 'View all';

  const state = useReviewModel();

  React.useEffect(() => {
    !isModalActive && setReviews(state);
  }, [isModalActive]);

  return (
    <SectionWithHeader
      title={sectionLabel}
      showButton={reviews && reviews?.reviews?.length > 0}
      btnLabel={viewAllLabel}
      buttonType="link"
      btnAction={handleOnViewAll.bind(null, true)}
    >
      {reviews && state && (
        <StyledReviewsPreviewWrapper>
          <StyledCarouselWrapper>
            <ReviewsCarousel reviewModel={state} />
          </StyledCarouselWrapper>
        </StyledReviewsPreviewWrapper>
      )}
    </SectionWithHeader>
  );
};

export default ReviewsPreview;
